import { BaseballEventDetailIdHalfValues } from '@collector/sportsapi-client-legacy'

export function getPitchingBatting<T>(
  eventDetailHalfValue: BaseballEventDetailIdHalfValues,
  home: T,
  away: T,
): [T, T] {
  const isTopHalf = eventDetailHalfValue === 'top'
  const pitching = isTopHalf ? home : away
  const batting = isTopHalf ? away : home

  return [pitching, batting]
}
